import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MedicationData } from '../../model/medicationData';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model/lifestyle.model';
import { SyncService } from 'src/app/pages/medical-underwriting/services/sync.service';
import { tabSquareActiveModel, MedicationQuestionStoreModel, TabQuesObjList, EmitterToCtlTypeModelTabSquare, AccordQuestionStoreModel, TabSquareMandatoryErrorModel } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { Tooltip } from 'src/app/model/tooltip';
import { QuestionsToAPI, UnderWritingData } from 'src/app/pages/medical-underwriting/model/lifestyle.post.model';
import { Subscription } from 'rxjs/Subscription';
import { UtilService } from 'src/app/shared/services/api-services/util.service';
import { AlertModal } from 'src/app/model/alert';
import { ActivatedRoute } from '@angular/router';

const MEDICATION = "Medication";

@Component({
    selector: 'app-tab-square-button',
    templateUrl: './tab-square-button.component.html',
    styleUrls: ['./tab-square-button.component.scss']
})

export class TabSquareButtonComponent implements OnInit, OnDestroy {

    tabList: MedicationData[];
    disableAddBtn: boolean = false;
    @Input() tabSquareQuesObj: LifeStyleQuestion;
    @Input() parent: UntypedFormGroup;
    controlName: string;
    @Input() accordIndexToAppend: number;
    @Input() objToReferForAccord: AccordQuestionStoreModel;
    @Input() resetTabSquare: boolean;
    @Input() editMode: boolean;
    domId: string;
    prefix: string;
    private questionModels: QuestionsToAPI[];
    btnName: string;
    maxLimit: number = 1;
    jsonSectionToRefer: string;
    quesIdToSetActive: string;
    errorMsg: string;
    mandatoryErrorMsg: string;
    errorMsgFlag: boolean = false;
    subscription: Subscription;
    public tooltipModalConfig: AlertModal;
    tooltipModal;
    displayTooltipAlert: boolean = false;
    @Output() tabSquareEmitter: EventEmitter<number> = new EventEmitter<number>();
    @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
    @Output() addTabSquareEmitter: EventEmitter<EmitterToCtlTypeModelTabSquare> = new EventEmitter<EmitterToCtlTypeModelTabSquare>();
    @Output() switchTabSquareEmitter: EventEmitter<EmitterToCtlTypeModelTabSquare> = new EventEmitter<EmitterToCtlTypeModelTabSquare>();
    @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
    recurrenceBackendJsonList: QuestionsToAPI[] = [];

    medicationForm: UntypedFormGroup;

    constructor(private fb: UntypedFormBuilder, private syncService: SyncService,
        private utilService: UtilService,
        private utilityServiceForMedicalService: UtilityServiceForMedicalService,
        private activatedRoute: ActivatedRoute) {
            this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    }

    ngOnInit() {
        this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
        this.subscription = this.utilService.updateEditForm.subscribe(res => {
            if (res) {
                this.editMode = false;
            }
            if (res && res.value && res.value.id && res.action && (this.tabSquareQuesObj.id === res.value.id)) {
                if (res.action === "add-tab") {
                    this.addTabFunToProceed();
                }
                if (res.action === "delete-tab" && res.extraParam) {
                    this.deleteTabFunToProceed(res.extraParam);
                }
            }
        });
        this.onLoadFunction();
        //this.resetFormError();
        this.resetFormError();
        let label: string = (this.tabSquareQuesObj.questionLabel).toLowerCase();
        this.errorMsg = "Please answer all the questions about this " + label + " before adding or switching another type of " + label;
    }

    onLoadFunction() {
        this.quesIdToSetActive = this.utilityServiceForMedicalService.getAccordionPrefix(this.tabSquareQuesObj.id, this.accordIndexToAppend);
        this.prefix = this.utilityServiceForMedicalService.getAccordionWithoutQuesIdPrefix(this.accordIndexToAppend);
        this.domId = this.utilityServiceForMedicalService.getDomId(this.tabSquareQuesObj.id, this.accordIndexToAppend, null);
        this.controlName = this.utilityServiceForMedicalService.getControlName(this.tabSquareQuesObj.id, this.accordIndexToAppend);
        this.parent.addControl(this.controlName, this.fb.control(this.tabSquareQuesObj.defaultResponseValue, (this.tabSquareQuesObj.mandatoryResponse.toUpperCase() === 'YES') ? Validators.required : null));
        this.jsonSectionToRefer = (MEDICATION === this.tabSquareQuesObj.sectionNameToRefer) ? MEDICATION : null;
        let tempSRecurrence = this.utilityServiceForMedicalService.getSecRecurrenceNumber(this.tabSquareQuesObj.id, this.jsonSectionToRefer);
        this.maxLimit = Number(tempSRecurrence);// getSecRecuarnceFromJso()
        this.btnName = this.tabSquareQuesObj.questionLabel;
        if (this.objToReferForAccord && !this.resetTabSquare) {
            //console.log(this.objToReferForAccord);
            this.questionModels = this.utilityServiceForMedicalService.getQuestionsModelForTabSquareFromAccord(this.objToReferForAccord, this.tabSquareQuesObj.id);
        }
        else if (!this.resetTabSquare) {
            let temp = this.utilityServiceForMedicalService.getAnswerFromStore(this.tabSquareQuesObj.id);
            this.questionModels = temp ? temp.questionModels : null;
        }
        else {
            //no action required
        }
        // questionModels should be null if resetTabSquare is true 
        if (this.questionModels && this.questionModels.length > 0) {
            let numberOfTabs = this.utilityServiceForMedicalService.getNumberOfSameIndexInstance(this.questionModels);
            this.createTabListBasedNumberOfTabs(numberOfTabs);
            this.recursiveFun(0);
        }
        else {
            this.createTabListBasedNumberOfTabs(1);
            this.setActiveTab(0);
            this.setActiveTabObjInfoInService(0, false); // false - it could be for partial quote with response value
        }
    }

    recursiveFun(tempIndex: number): void {
        let result = this.questionModels.filter(
            item => item.index === tempIndex.toString());
        if (result && (result.length > 0)) {
            let temp = this.createObjMedQuestionStoreModel(tempIndex, result);
            this.syncService.setMedicationQuestionList(temp);
            tempIndex++;
            this.recursiveFun(tempIndex);
        }
    }


    createObjMedQuestionStoreModel(tempIndex: number, recurrenceBackendJsonList: QuestionsToAPI[]): MedicationQuestionStoreModel {
        let temp = new MedicationQuestionStoreModel();
        temp.indexToSave = tempIndex.toString();
        temp.medQuesId = this.quesIdToSetActive;
        temp.questionList = recurrenceBackendJsonList;
        return temp;
    }

    createTabListBasedNumberOfTabs(numberOfTabs: number) {
        this.tabList = [];
        for (let i = 0; i < numberOfTabs; i++) {
            let temp = { id: i, name: this.btnName, selected: true, invalidTab: false };
            this.tabList.push(temp);
        }
    }

    setActiveTabObjInfoInService(activeIndex: number, addTab: boolean): void { // this will set active tab index along with parent and dependent question.
        // but it will not prepare backend json. on click of Next btn , this will be useful to prepare backend json
        let tempQuestIds: string[] = this.utilityServiceForMedicalService.getQuesIdListFromDummyQuestion(this.tabSquareQuesObj);
        let nextQuestionObjList = this.utilityServiceForMedicalService.getQuestionListForGivenIds(tempQuestIds, this.jsonSectionToRefer);

        if (addTab) {
            nextQuestionObjList.forEach(element => {
                element.responseValueByUser = undefined;
            });
        }
        let tempActiveTabObj = new tabSquareActiveModel();
        tempActiveTabObj.isActive = true;
        tempActiveTabObj.activeIndex = activeIndex;
        tempActiveTabObj.tabQuestionId = this.quesIdToSetActive;
        tempActiveTabObj.nextQuestionObjList = nextQuestionObjList;
        tempActiveTabObj.jsonToRefer = this.jsonSectionToRefer;
        tempActiveTabObj.accordPrefix = this.prefix ? this.prefix : null;
        let temp: tabSquareActiveModel[] = this.syncService.getTabSquareAsActive();
        let matchQuesFound: boolean;
        let i = temp.length
        while (i--) {

            if (temp[i].tabQuestionId === this.quesIdToSetActive) {
                temp.splice(i, 1);
            }
        }
        temp.push(tempActiveTabObj);
        this.syncService.setTabSquareAsActive(temp);
    }

    ngAfterViewInit() {
        if (!this.questionModels) {
            setTimeout(() => {
                this.tabSquareEmitter.emit(this.accordIndexToAppend);
                this.resetFormError();
            }, 300);
        }
        else {
            setTimeout(() => {
                let tabZero: MedicationData = { id: 0, name: this.btnName, selected: true, invalidTab: false };
                this.switchTab(tabZero);
                this.resetFormError();
            }, 300);

        }
    }

    getCloseIconSrc(i): void {
        this.tabList.forEach(val => val.selected = false);
        this.tabList[i].selected = !this.tabList[i].selected;
    }

    setActiveTabForDelete(tabModelObj) {
        if (tabModelObj.id === 0) {
            this.setActiveTab(0);
        }
        else {
            this.setActiveTab(tabModelObj.id - 1);
        }
    }

    deleteTab(tabModelObj: MedicationData) {
        if (this.editMode) {
            const payload = {
                value: this.tabSquareQuesObj,
                action: "delete-tab",
                extraParam: tabModelObj
            };
            this.editModelHandler.emit(payload);
        } else {
            this.deleteTabFunToProceed(tabModelObj);
        }
    }

    deleteTabFunToProceed(tabModelObj: MedicationData) {
        this.mandatoryErrorMsg = null;
        if (this.tabList.length > 1) {
            this.saveDataForActiveIndex(); // get current active id
            let i = this.tabList.length;
            while (i--) {
                if (this.tabList[i].id === tabModelObj.id) {
                    this.tabList.splice(i, 1);
                }
            }
            let temp = this.tabList;
            this.tabList = [];
            temp.forEach((element, index) => {
                let tabObj = { id: index, name: this.btnName, selected: false, invalidTab: false };
                this.tabList.push(tabObj);
            });
            this.setActiveTabForDelete(tabModelObj);


            this.syncService.deleteIndexForMedicationQuestionList(tabModelObj.id, this.tabSquareQuesObj.id);
            this.setActiveTabObjInfoInService(this.getActiveTabIndex().id, false);
            this.switchTabSquareEmitter.emit(new EmitterToCtlTypeModelTabSquare(this.accordIndexToAppend, this.getActiveTabIndex().id, this.objToReferForAccord));
        }
        else {

        }
        this.setDisableBtnFlag();
    }

    setActiveTab(activeIndex: number) {
        this.tabList.forEach(tabObj => {
            tabObj.selected = false;
        });
        this.tabList[activeIndex].selected = true;
    }

    setDisableBtnFlag() {
        let totalTabs = this.tabList.length;
        this.disableAddBtn = (totalTabs >= this.maxLimit) ? true : false;
        console.log(totalTabs + "  "+ this.disableAddBtn)
    }

    addTab(): void {
        if (this.editMode) {
            const payload = {
                value: this.tabSquareQuesObj,
                action: "add-tab"
            };
            this.editModelHandler.emit(payload);
        } else {
            this.addTabFunToProceed();
        }
    }

    addTabFunToProceed() {
        let validateFormForTabSquareQuestions = this.validateFormForTabSquareQuestions();
        if (validateFormForTabSquareQuestions) {
            let totalTabs = this.tabList.length;
            if (totalTabs < this.maxLimit) {
                this.storeInService(this.getActiveTabIndex().id);
                let temp = this.tabList.length - 1;
                //prevId => Fetching id of last element
                let prevId = this.tabList[temp].id;
                //temp2 => index Number of new tab
                let newIndex = prevId + 1;
                this.tabList.push({ id: newIndex, name: this.btnName, selected: false, invalidTab: false });
                this.setActiveTab(newIndex);
                this.setActiveTabObjInfoInService(this.tabList.length - 1, true);
                this.addTabSquareEmitter.emit(new EmitterToCtlTypeModelTabSquare(this.accordIndexToAppend, (this.tabList.length - 1), this.objToReferForAccord));
                this.resetFormError();

            }
            else {
            }
            this.setDisableBtnFlag();
        }
    }

    prepareForDepQuestionsForResValueAsString(quesObj: LifeStyleQuestion, selectedValue: string, jsonToReferFromRec: string, indexNumberToStore: number) {
        if (quesObj.nextStep) {
            quesObj.nextStep.forEach(next => {
                if (next.nextStepSelectedResponse === selectedValue && next.nextStepValue && next.nextStepType !== 'File') {
                    let nextQuestionIdList: string[] = next.nextStepValue;
                    let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(nextQuestionIdList, jsonToReferFromRec);
                    nextQuestionObjList.forEach(nextQuestionObj => {

                        let referenceQueId: string = quesObj.id;
                        let backendQuestionObjForDependentQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.parent, nextQuestionObj, this.prefix);
                        backendQuestionObjForDependentQues.index = (indexNumberToStore).toString();
                        this.recurrenceBackendJsonList.push(backendQuestionObjForDependentQues);
                        this.recursiveFunForDependentQuestion(backendQuestionObjForDependentQues.responseValue, nextQuestionObj, jsonToReferFromRec, indexNumberToStore);
                    });
                }
            });
        }
    }

    recursiveFunForDependentQuestion(selectedValueForMandatoryQues: any, quesObj: LifeStyleQuestion, jsonToReferFromRec: string, indexNumberToStore: number) {
        if (typeof selectedValueForMandatoryQues === 'string' && selectedValueForMandatoryQues && quesObj.responseValue && quesObj.responseValue.length > 0) {
            // for the values where response value can be one. like input , number, radiobtn (yes/no)
            this.prepareForDepQuestionsForResValueAsString(quesObj, selectedValueForMandatoryQues, jsonToReferFromRec, indexNumberToStore);
        }
    }

    storeInService(indexNumberToStore: number) {
        let tempQuestIds: string[] = this.utilityServiceForMedicalService.getQuesIdListFromDummyQuestion(this.tabSquareQuesObj);
        let jsonSectionToRefer = (MEDICATION === this.tabSquareQuesObj.sectionNameToRefer) ? MEDICATION : null;
        let nextQuestionObjList = this.utilityServiceForMedicalService.getQuestionListForGivenIds(tempQuestIds, jsonSectionToRefer);

        this.recurrenceBackendJsonList = [];
        nextQuestionObjList.forEach(recQuesObj => {
            let recurrenceBackendJson: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.parent, recQuesObj, this.prefix);
            recurrenceBackendJson.index = (indexNumberToStore).toString();
            this.recurrenceBackendJsonList.push(recurrenceBackendJson);
            let selectedValueForMandatoryQues = recurrenceBackendJson.responseValue;
            this.recursiveFunForDependentQuestion(selectedValueForMandatoryQues, recQuesObj, jsonSectionToRefer, indexNumberToStore);
        });
        let temp = new MedicationQuestionStoreModel();
        temp.indexToSave = (indexNumberToStore).toString();
        let quesIdToSet = this.prefix ? (this.prefix + this.tabSquareQuesObj.id) : this.tabSquareQuesObj.id
        temp.medQuesId = quesIdToSet;
        temp.questionList = this.recurrenceBackendJsonList;
        this.syncService.setMedicationQuestionList(temp);
    }

    getActiveTabIndex(): MedicationData {
        let activeTab = this.tabList.find((element) => element.selected === true);
        return activeTab;
    }

    saveDataForActiveIndex() { // this will set active index and also prepare backend json . this will help while switching tabs

        let tempActiveTabList = this.syncService.getTabSquareAsActive();
        //console.log(tempActiveTabList);
        if (tempActiveTabList && tempActiveTabList.length > 0) {
            tempActiveTabList.forEach(tab => {
                if (tab.isActive && tab.nextQuestionObjList && (tab.tabQuestionId === this.quesIdToSetActive)) {
                    this.utilityServiceForMedicalService.prepareCurrentActiveFormTabSquare(this.parent, tab.nextQuestionObjList, tab.activeIndex, tab.tabQuestionId, this.jsonSectionToRefer, this.prefix);
                }
            });

        }
    }

    switchTab(tabModelObj: MedicationData) {
        if (tabModelObj) {
            let validateFormForTabSquareQuestions = this.validateFormForTabSquareQuestions();
            if (validateFormForTabSquareQuestions) {
                this.saveDataForActiveIndex(); // get current active id && call prepareCurrentActiveFormTabSquare to create backendjson to retain values
                this.switchTabSquareEmitter.emit(new EmitterToCtlTypeModelTabSquare(this.accordIndexToAppend, tabModelObj.id, this.objToReferForAccord));
                this.setActiveTab(tabModelObj.id); // set the tab which needs to be highlighted
                this.setActiveTabObjInfoInService(this.getActiveTabIndex().id, false);
                this.resetFormError();
            }
        }
    }

    validateFormForTabSquareQuestions(): boolean { // this will set active index and also prepare backend json . this will help while switching tabs
        let isValidFormForTabSquare = true;
        let tempActiveTabList = this.syncService.getTabSquareAsActive();
        this.mandatoryErrorMsg = null;
        if (tempActiveTabList && tempActiveTabList.length > 0) {
            tempActiveTabList.forEach(tab => {
                if (tab.isActive && tab.nextQuestionObjList && (tab.tabQuestionId === this.quesIdToSetActive)) {
                    isValidFormForTabSquare = this.utilityServiceForMedicalService.validateFormForTabSquareQuesList(tab, this.parent, this.jsonSectionToRefer, this.accordIndexToAppend);
                    this.parent.controls[this.controlName].markAsTouched();
                    if (!isValidFormForTabSquare) {
                        this.tabList[tab.activeIndex].invalidTab = true;
                        this.parent.controls[this.controlName].setErrors({ invalid: true });
                    }
                    else {
                        this.resetFormError();
                    }
                }
            });

        }
        return isValidFormForTabSquare;
    }

    resetFormError() {
        this.parent.controls[this.controlName].markAsUntouched();
        this.parent.controls[this.controlName].setErrors(null);
        this.tabList.forEach(element => {
            element.invalidTab = false;
        });
    }

    ngOnDestroy() {
        if (this.parent.get(this.controlName)) {
            this.parent.controls[this.controlName].markAsUntouched();
            this.parent.controls[this.controlName].setErrors(null);
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    initializeToolTipDateComp(questionObj: LifeStyleQuestion): Tooltip {
        return new Tooltip(questionObj.helpText, '', false);
    }

    @HostListener('document:tabSquareValidation', ['$event'])
    handleTabSquareValidation(event) {
        if (this.parent.get(this.controlName)) {
            this.mandatoryErrorMsg = null;
            this.validateFormForTabSquareQuestions();
        }

    }

    displayMandatoryMsg(obj: TabSquareMandatoryErrorModel) {
        let uniqueArray = obj.indexNumberList.filter(function (item, pos) {
            return obj.indexNumberList.indexOf(item) == pos;
        });
        let msg = "";
        if (uniqueArray.length === 1) {
            this.mandatoryErrorMsg = "Please answer to " + this.tabSquareQuesObj.questionLabel.toLocaleLowerCase() + " - " + (Number(uniqueArray[0]) + 1);
        }
        else {
            for (let i = 0; i < uniqueArray.length; i++) {
                msg = msg + ", " + (Number(i) + 1);
            }
            this.mandatoryErrorMsg = "Please answer to " + this.tabSquareQuesObj.questionLabel.toLocaleLowerCase() + " - " + msg;
        }
    }

    closeModal(){
        this.displayTooltipAlert = false;
    }

    @HostListener('document:tabSquareMandatoryEvt', ['$event'])
    handelTabSquareMandatoryEvt(event) {
        this.mandatoryErrorMsg = null;
        if (event && event.detail) {
            let tabSquareToShowObj: TabSquareMandatoryErrorModel[] = event.detail;
            tabSquareToShowObj.forEach(element => {
                let idToSearch: string = element.quesIdToMap;
                let accordIndexFromTabObj: string;
                let accordIndexFromTabObjNumber: Number;
                if (element.quesIdToMap.includes("A")) { // heart conditions
                    let temp = element.quesIdToMap.split("-");
                    idToSearch = temp[1];
                    accordIndexFromTabObj = temp[0];
                    accordIndexFromTabObjNumber = Number(accordIndexFromTabObj.charAt(1));
                }
                if (accordIndexFromTabObj && (this.accordIndexToAppend === accordIndexFromTabObjNumber) &&
                    (idToSearch === this.tabSquareQuesObj.id)) { // means accordion present
                    this.displayMandatoryMsg(element);
                }
                else if (!accordIndexFromTabObj && (idToSearch === this.tabSquareQuesObj.id)) {// means accordion present
                    this.displayMandatoryMsg(element);
                }
            });

        }

    }

    displayTooltipMessage(){
        this.onDisplayMobileTooltipEmitter.emit();
    }
}
